// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3HSkd","topBottomGutter":"Layout_topBottomGutter__VN4p2"};